import { sanitizeRichContentHtml } from '~/portal/utils/shared/sanitizeHtml'

export const sanitizeLandingPageHtml = (html: string): string => sanitizeRichContentHtml(html)
